/** @jsx jsx */
import { jsx, ThemeUIStyleObject, Heading as ThemeUIHeading } from "theme-ui"
import React from "react"
import { PrimitiveProps } from "@styles/types"

type HeadingTypes =
  | React.ComponentPropsWithoutRef<"h1">
  | React.ComponentPropsWithoutRef<"h2">
  | React.ComponentPropsWithoutRef<"h3">
  | React.ComponentPropsWithoutRef<"h4">
  | React.ComponentPropsWithoutRef<"h5">
  | React.ComponentPropsWithoutRef<"h6">

export interface HeadingProps extends PrimitiveProps, HeadingTypes {
  as?: React.ElementType
}

export const headingStyles: ThemeUIStyleObject = {
  maxWidth: "100%",
  whiteSpace: "pre-line",
}

const Heading: React.FC<HeadingProps> = ({ as, children, sx, ...props }) => (
  <ThemeUIHeading
    as={as}
    variant="heading"
    sx={{ ...headingStyles, ...sx }}
    {...props}
  >
    {children}
  </ThemeUIHeading>
)

Heading.defaultProps = {
  as: "h2",
}

export { Heading }
